<!--
 * @description: 首页图片
 * @param: 
 * @return: 
-->
<template>
	<div class="chart-reports-main">
		<div class="imgLogo"><img src="../assets/images/light/comLogo.png" alt="" srcset=""></div>
		<!-- <panel-container class="chart-reports-main-condition">
			<field type="select" labelText="组织机构" class="chart-reports-main-condition-input"
				:selectRemoteSearchData="orgSelectRemoteSearchData" v-model:value="condition.organiId"
				:clearable="true">
			</field>
			<field type="select" labelText="工器具小类" class="chart-reports-main-condition-input"
				:selectRemoteSearchData="smallClassData" v-model:value="condition.class2code" :clearable="true"></field>
			<field type="date" labelText="统计时间" class="chart-reports-main-condition-input"
				v-model:value="condition.startTime" :clearable="true"></field>
			<field type="date" labelText="-" class="chart-reports-main-condition-input"
				v-model:value="condition.endTime" :clearable="true">
			</field>
			<search-button class="chart-reports-main-condition-search-button" @buttonClick="search">查询</search-button>
		</panel-container> -->
		<!-- <div class="chart-reports-main-body">
			<div class="chart-reports-main-body-row">
				<div class="chart-reports-main-body-row-cell">
					<card-panel title="领用工器具次数">
						<chart :option="getToolsTimes"></chart>
					</card-panel>
				</div>
				<div class="chart-reports-main-body-row-cell">
					<card-panel title="工器具归还频次">
						<chart :option="payBackTimes"></chart>
					</card-panel>
				</div>
			</div>
			<div class="chart-reports-main-body-row">
				<div class="chart-reports-main-body-row-cell">
					<card-panel title="机构下各单位出入库统计">
						<chart :option="orgEachUninWarehouseInfo"></chart>
					</card-panel>
				</div>
				<div class="chart-reports-main-body-row-cell">
					<card-panel title="出入库统计">
						<chart :option="warehouseInfo"></chart>
					</card-panel>
				</div>
			</div>
		</div> -->
	</div>
</template>

<script>
	import panelContainer from "@/components/panelContainer.vue"
	import field from "@/components/textField.vue"
	import searchButton from "@/components/searchButton.vue"
	import cardPanel from "@/components/cardPanel.vue"
	import chart from "@/components/vChart.vue"
	import tabelApi from "@/api/tabel.js"
	import {
		// getToolsTimes,
		// payBackTimes,
		// orgEachUninWarehouseInfo,
		// warehouseInfo
	} from "@/api/index.js"
	import {
		errMsg
	} from "@/notify/index.js"
	import {
		defineComponent,
		reactive,
		toRefs,
		onMounted
	} from "vue"

	export default defineComponent({
		name: "ChartReports",
		components: {
			panelContainer,
			field,
			searchButton,
			cardPanel,
			chart
		},
		setup() {
			let data = reactive({
				condition: {
					organiId: "",
					class2code: "",
					startTime: null,
					endTime: null
				},
				getToolsTimes: {
					tooltip: {
						trigger: 'item'
					},
					legend: {
						orient: 'vertical',
						left: 'left',
					},
					series: [{
						name: '访问来源',
						type: 'pie',
						radius: '50%',
						data: [{
								value: 1048,
								name: '搜索引擎'
							},
							{
								value: 735,
								name: '直接访问'
							},
							{
								value: 580,
								name: '邮件营销'
							},
							{
								value: 484,
								name: '联盟广告'
							},
							{
								value: 300,
								name: '视频广告'
							}
						],
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						}
					}]
				},
				payBackTimes: {
					tooltip: {
						trigger: 'axis'
					},
					xAxis: {
						type: 'category',
						axisLabel: {
							rotate: 45
						},
						data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
					},
					yAxis: {
						type: 'value'
					},
					series: [{
						data: [820, 932, 901, 934, 1290, 1330, 1320],
						type: 'line',
						smooth: true
					}]
				},
				orgEachUninWarehouseInfo: {
					tooltip: {
						trigger: 'axis',
						axisPointer: { // 坐标轴指示器，坐标轴触发有效
							type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
						}
					},
					legend: {
						data: ['入库数量', '出库数量']
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					xAxis: [{
						type: 'category',
						data: ['工器具单位', '机械单位']
					}],
					yAxis: [{
						type: 'value'
					}],
					series: [{
							name: '入库数量',
							type: 'bar',
							emphasis: {
								focus: 'series'
							},
							data: [320, 332]
						},
						{
							name: '出库数量',
							type: 'bar',
							stack: '广告',
							emphasis: {
								focus: 'series'
							},
							data: [120, 132]
						}
					]
				},
				warehouseInfo: {
					tooltip: {
						trigger: 'axis'
					},
					xAxis: {
						type: 'category',
						data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
						axisLabel: {
							rotate: 45
						},
					},
					yAxis: {
						type: 'value'
					},
					series: [{
						data: [120, 200, 150, 80, 70, 110, 130],
						type: 'line',
						smooth: true
					}]
				}
			})

			let methods = {
				search() {
					// getToolsTimes(data.condition).then(result => {
					// 	if (result.code == 0) {
					// 		data.getToolsTimes.series[0].data = result.data
					// 	} else {
					// 		errMsg(result.message)
					// 	}
					// })

					// payBackTimes(data.condition).then(result => {
					// 	if (result.code == 0) {
					// 		data.payBackTimes.xAxis.data = result.data.category
					// 		data.payBackTimes.series[0].data = result.data.data
					// 	} else {
					// 		errMsg(result.message)
					// 	}
					// })

					// orgEachUninWarehouseInfo(data.condition).then(result => {
					// 	if (result.code == 0) {
					// 		let legends = result.data.map(m => m.companyName)
					// 		data.orgEachUninWarehouseInfo.xAxis.data = legends
					// 		data.orgEachUninWarehouseInfo.series[0].data = result.data.map(m => m.inData)
					// 		data.orgEachUninWarehouseInfo.series[1].data = result.data.map(m => m.outDate)
					// 	} else {
					// 		errMsg(result.message)
					// 	}
					// })

					// warehouseInfo(data.condition).then(result => {
					// 	if (result.code == 0) {
					// 		data.warehouseInfo.xAxis.data = result.data.category
					// 		data.warehouseInfo.series[0].data = result.data.data
					// 	} else {
					// 		errMsg(result.message)
					// 	}
					// })
				},
				async orgSelectRemoteSearchData() {
					let source = await tabelApi.unitManagementDataAll()
					if (source.code == 0) {
						let dataArray = source.data.list.map(({
							organiId,
							organiName
						}) => {
							return {
								label: organiName,
								value: organiId
							}
						})
						let total = 0;

						return {
							total,
							data: dataArray
						}
					} else {
						errMsg(source.message)
					}
				},
				async smallClassData() {

					let source = await tabelApi.smallClassListAll();

					if (source.code == 0) {
						let dataArray = source.data.list.map(({
							code,
							name
						}) => {
							return {
								label: name,
								value: code
							}
						})
						let total = 0;

						return {
							total,
							data: dataArray
						}
					} else {
						errMsg(source.message)
					}
				}
			}

			onMounted(() => {
				methods.search()
			})

			return {
				...toRefs(data),
				...methods
			}
		}
	})
</script>

<style lang="scss" scoped>
	.chart-reports-main {
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		overflow: hidden;

		.chart-reports-main-condition {
			display: flex;
			width: 100%;
			height: fit-content;
			display: flex;
			align-items: center;
			align-content: center;
			padding-left: 24px;
			padding-right: 24px;
			padding-top: 10px;
			padding-bottom: 10px;
			box-sizing: border-box;
			overflow: hidden;

			.chart-reports-main-condition-input {
				width: auto;
			}

			.chart-reports-main-condition-search-button {
				margin-left: 20px;
			}
		}

		.chart-reports-main-body {
			flex: 1;
			width: 100%;
			display: flex;
			flex-direction: column;
			margin-top: 30px;
			box-sizing: border-box;
			padding: 1px;
			flex-flow: column;
			overflow: auto;

			.chart-reports-main-body-row {
				//flex: 1;
				height: auto;
				width: 100%;
				display: flex;

				&:last-child {
					margin-top: 30px;
				}

				.chart-reports-main-body-row-cell {
					height: 500px;
					flex: 1;

					&:last-child {
						margin-left: 30px;
					}
				}
			}
		}

		.imgLogo{
			width: 100%;
			height: 100%;
			text-align: center;

			img{
				width: 65%;
				margin: 0 auto;
			}
		}
	}
</style>
